<template>
  <div>
    <a-input-search placeholder="input search text" enter-button @search="onSearch" />
    <br /><br />
    <a-button type="primary" @click="newbasestation()">
      新建
    </a-button>
    <a-table :columns="columns" :data-source="data">
      <a slot="active" slot-scope="text,record"  @click="getactive(record.sn)">激活码</a>
      <a slot="action" slot-scope="text,record"  @click="handleEdit(record.sn)">编辑</a>
    </a-table>  
  </div>
</template>
<script>
const columns = [
        {
          title: '设备号',
          dataIndex: 'sn',
          scopedSlots: { customRender: 'sn' },
        },{
          title: '描述',
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' },
        },
        {
          title: '位置',
          dataIndex: 'location',
          scopedSlots: { customRender: 'location' },
        },
      ];



export default {
  data() {
    let param = {
        page:1,
        pagenum:10
    }
    let terminallist;
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/basestation/list',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       this.data = response.data
       this.Showpage = true
       console.log(response)       //请求成功返回的数据
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    return {
      Showpage:false,
      data:terminallist,
      columns
    };
  },
  methods:{
    
    onSearch(value){
      this.$store.state.basestation = value;
      this.$router.push('/home/newbasestation');
    },
    newbasestation(){
      
      this.$router.push('/home/newbasestation');
    }
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BasestationList.vue